<div class="work-hero-wrap" *ngFor = 'let hero of heros'>
  <div class="hero-bckgrnd" style="background-color: #1f2225">
    <img src="../../../assets/img/hero/{{hero.mock}}" alt="" loading="lazy" />
  </div>
</div>